/**
 * @name isSlotted
 * @description Checks if the given element has slot with or without name
 * @example
 * import { isSlotted } from '@workbench/core';
 *
 * isSlotted(element, 'content'); // true
 */
export const isSlotted = (element: HTMLElement, name: string): boolean => {
  return Boolean(element.querySelector(`[slot='${name}']`));
};
